const HOME_ROUTE = "/";
const LIVE_DEMO_ROUTE = "/virtual-tryon/live-demo";
const TRYON_HOMEROUTE = "/virtual-tryon";
const CONTACT_US_ROUTE = "/contact-us";
const CASE_STUDIES_ROUTE = "/case-study/virtual-tryon";
const ABOUT_US_ROUTE = "/about-us";
const SERVICES_ROUTE = "/services";
const SIGNUP_ROUTE = "/account/signup";
const LOGIN_ROUTE = "/account/login";

export {
  HOME_ROUTE,
  LIVE_DEMO_ROUTE,
  CONTACT_US_ROUTE,
  TRYON_HOMEROUTE,
  CASE_STUDIES_ROUTE,
  ABOUT_US_ROUTE,
  SERVICES_ROUTE,
  SIGNUP_ROUTE,
  LOGIN_ROUTE,
};
